import {ZIDX, ZIDXPage} from "../../standalone/standaloneLibrary.js";
import jQuery from "jquery";
const $ = jQuery;


export class ZIDXAccountAIBotEmbedCode implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountAIBotEmbedCodeContainer";
    }
    render(){
        // console.log("AI Bot Embed Code");

        let self = this;
        let container = this.zidx.peakidxShadowRoot
            .querySelector(".zidxAccountAIBotEmbedCodeContainer")!;

        // Regenerate on any field change. "input" covers typing in text/number/
        // color fields; "change" covers the theme radios. Scoped through the
        // container element so it resolves correctly inside the shadow root.
        $(container).find("input, select, textarea").on("input change", function () {
            self.generateAIChatEmbedCode();
        });

        this.generateAIChatEmbedCode();
    }

    // Reads a form control's value by name. Radios return the checked option;
    // everything else (text, color, number, hidden, textarea, select) returns
    // its .value.
    private getValue(container: Element, name: string): string {
        let checked = container.querySelector(`input[name="${name}"]:checked`) as HTMLInputElement | null;
        if (checked) {
            return checked.value;
        }
        let el = container.querySelector(`[name="${name}"]`) as
            HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement | null;
        return el ? el.value : "";
    }

    // Free-text fields can contain characters that break an HTML attribute,
    // so escape them before injecting into data-* attributes.
    private escapeAttr(value: string): string {
        return value
            .replace(/&/g, "&amp;")
            .replace(/"/g, "&quot;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;");
    }

    generateAIChatEmbedCode() {
        let container = this.zidx.peakidxShadowRoot
            .querySelector(".zidxAccountAIBotEmbedCodeContainer")!;

        let esc = (name: string) => this.escapeAttr(this.getValue(container, name));

        let aiSearch = esc("aiSearchUrl"); // server-generated, read-only
        let heading = esc("heading");
        let subheading = esc("subheading");
        let placeholder = esc("placeholder");
        let buttonText = esc("buttonText");
        let buttonColor = esc("buttonColor");
        let theme = esc("theme");
        let maxLength = esc("maxLength");
        // Parse the raw (unescaped) value; an empty/invalid URL must not throw out of render().
        let scriptTag = '';
        try {
            let url = new URL(this.getValue(container, "aiSearchUrl"));
            scriptTag = '<script src="' + this.escapeAttr(url.protocol + "//" + url.host) + '/static/ai-chat-embed.js" defer><' + '/script>';
        } catch (e) {
            scriptTag = '<!-- AI search URL is missing or invalid -->';
        }


        let textareaElement = this.zidx.peakidxShadowRoot
            .querySelector(".zidxAccountAIBotEmbedCodeContainer #aiChatEmbedCode") as HTMLTextAreaElement | null;
        if (textareaElement) {
            let code =
                '<!-- insert where you wish the form to appear -->\n' +
                '<div class="aiChatEmbedContainer"\n' +
                '   data-ai-search="' + aiSearch + '"\n' +
                '   data-heading="' + heading + '"\n' +
                '   data-subheading="' + subheading + '"\n' +
                '   data-placeholder="' + placeholder + '"\n' +
                '   data-button-text="' + buttonText + '"\n' +
                '   data-button-color="' + buttonColor + '"\n' +
                '   data-theme="' + theme + '"\n' +
                '   data-max-length="' + maxLength + '"></div>\n\n' +
                '<!-- insert near end of document -->\n' +
                scriptTag;
            textareaElement.value = code;
        }
        let textareaElementWordpress = this.zidx.peakidxShadowRoot
            .querySelector(".zidxAccountAIBotEmbedCodeContainer #aiChatEmbedWordpressCode") as HTMLTextAreaElement | null;
        if (textareaElementWordpress) {
            let code =
                '[peakidx-react-component name="ai-chat-embed" ' +
                '   ai-search="' + aiSearch + '"' +
                '   heading="' + heading + '"' +
                '   subheading="' + subheading + '"' +
                '   placeholder="' + placeholder + '"' +
                '   button-text="' + buttonText + '"' +
                '   button-color="' + buttonColor + '"' +
                '   theme="' + theme + '"' +
                '   max-length="' + maxLength + '"]';
                // '<script src="'+url.protocol+"//"+url.host+'/static/ai-chat-embed.js" defer><' + '/script>';
            textareaElementWordpress.value = code;
        }
    }
}